import styles from './Services.module.css';

const SERVICES = [
  {
    no: '01',
    title: 'Strategic Consulting',
    chips: ['Strategy', 'Optimization', 'ROI Analysis'],
    desc: 'NetSuite optimization roadmaps, process improvement, and implementation guidance from nearly two decades of hands-on experience.',
  },
  {
    no: '02',
    title: 'Custom Development',
    chips: ['SuiteScript', 'Workflows', 'Custom Apps'],
    desc: 'SuiteScript, SuiteFlow, custom records, and full applications — built by a senior NetSuite developer to your exact specifications.',
  },
  {
    no: '03',
    title: 'Integration Services',
    chips: ['API', 'Middleware', 'Real-time Sync'],
    desc: 'Connect NetSuite with ecommerce, CRM, warehouse, and third-party systems — and to AI agents over MCP. Eliminate data silos and brittle manual exports.',
  },
  {
    no: '04',
    title: 'Training & Mentoring',
    chips: ['Mentoring', 'Code Reviews', 'Enablement'],
    desc: 'Hands-on developer mentoring and team enablement — SuiteScript best practices, architecture and code reviews, and upskilling your in-house team so they can build and maintain with confidence.',
  },
  {
    no: '05',
    title: 'AI-Powered Solutions',
    chips: ['Enablement', 'Audit', 'Automation'],
    desc: "Train your team on NetSuite's native AI, run an AI-powered performance audit, and add transparent, explainable AI where it counts.",
  },
  {
    no: '06',
    title: 'Ongoing Support',
    chips: ['Managed Services', 'Training', 'Support'],
    desc: 'Proactive optimization, training, and a single point of contact who already knows your business inside and out.',
  },
];

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="wrap">
        <div className="reveal">
          <span className="eyebrow">Core Expertise</span>
          <h2 className="section-title" style={{ marginTop: 16 }}>
            NetSuite Services
          </h2>
          <p className="section-lead">
            Nearly two decades of hands-on NetSuite work — from strategy to SuiteScript to the systems
            that surround it, and the teams I train along the way.
          </p>
        </div>

        <div className={`${styles.svcList} reveal`}>
          {SERVICES.map((s) => (
            <div className={styles.svc} key={s.no}>
              <div className={styles.no}>{s.no}</div>
              <div>
                <h3>{s.title}</h3>
                <div className={styles.chips}>
                  {s.chips.map((c) => (
                    <span className="chip" key={c}>
                      {c}
                    </span>
                  ))}
                </div>
              </div>
              <p className={styles.desc}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
